import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import {
    GeoSingleResponse,
    GeoSingleResponseWithOs,
    OsResponse
} from '../../../../modules/back-office/models/geolocation-response';
import { D365Service } from '../../d365/d365.service';

@Injectable({
    providedIn: 'root'
})
export class EglGeolocationService {
    constructor(private d365Srv: D365Service) {}

    getTabletGeolocation(): Observable<GeoSingleResponseWithOs> {
        return this.d365Srv.getBrowserOS().pipe(
            switchMap((osRes: OsResponse) => {
                const os = osRes?.os ?? null;
                const isTablet = os === 'Android' || os === 'Linux' || os === 'iOS';

                return isTablet
                    ? this.d365Srv.getSingleGeolocation().pipe(map((geoRes: GeoSingleResponse) => ({ ...geoRes, os })))
                    : of({
                          position: null,
                          error: 'DEVICE_IS_NOT_TABLET',
                          os
                      } as GeoSingleResponseWithOs);
            })
        );
    }

    isTablet(): Observable<boolean> {
        return this.d365Srv
            .getBrowserOS()
            .pipe(map((osRes: OsResponse) => osRes?.os === 'Android' || osRes?.os === 'Linux' || osRes?.os === 'iOS'));
    }

    getWhitelistedTabletGeolocation(): Observable<Boolean> {
        return this.d365Srv.isAgentInGeolocationWhitelist().pipe(
            switchMap((isAllowed) => {
                if (isAllowed) {
                    return of(true);
                }
                return of(false);
            })
        );
    }

    distanceKm(lat1: number, lon1: number, lat2: number, lon2: number): number {
        const R = 6371; // km
        const toRad = (deg: number) => (deg * Math.PI) / 180;

        const dLat = toRad(lat2 - lat1);
        const dLon = toRad(lon2 - lon1);

        const a =
            Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);

        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        return R * c;
    }

    distanceMeters(lat1: number, lon1: number, lat2: number, lon2: number): number {
        return this.distanceKm(lat1, lon1, lat2, lon2) * 1000;
    }
}
